export default __webpack_public_path__ + "static/74-cc53cf716b76a4ba3569452c03d0e974.gif";